/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ResponsiveValue,
  useToast,
} from '@chakra-ui/react';
import { createElement } from 'react';
import { UseMutationOptions } from 'react-query';

export function RemoveModelModal<T>({
  modelName,
  form,
  onClose,
  isOpen,
  size = 'md',
}: {
  modelName: string;
  form: any;
  onClose: () => void;
  isOpen: boolean;
  size?: ResponsiveValue<string>;
}) {
  const toast = useToast();
  const options: UseMutationOptions<unknown, unknown, any> = {
    onSuccess() {
      toast({
        title: 'Sucesso',
        description: `${modelName} deletados com sucesso`,
        status: 'success',
      });
      onClose();
    },
    onError(error: any) {
      console.log('error', error);
      toast({
        title: 'Erro',
        description: `Não foi possivel deletar o(s) ${modelName}. Por favor verifique os dados e tente novamente ou entre em contato com suporte@partiu.com.br.`,
        status: 'error',
      });
    },
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter={'blur(5px)'} />
      <ModalContent minWidth={size} paddingBottom={'15px'}>
        <ModalHeader>Remover {modelName} em lotes</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{createElement(form, { onClose, toast, options })}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
